
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DutySummaryDonut = ({ summary = {} }) => {
  const {
    total_duties = 0,
    billed_duties = 0,
    not_billed_duties = 0,
    non_closed_duties = 0,
  } = summary;

  const values = [
    billed_duties,
    not_billed_duties,
    non_closed_duties,
  ];

  const data = {
    labels: ["Billed", "Not Billed", "Non Closed"],
    datasets: [
      {
        data: values,
        backgroundColor: [
          "#22c55e",
          "#f6c87aff",
          "#d3d4f3ff",
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    radius: "65%", // REDUCES THE OUTER CIRCLE SIZE
    cutout: "55%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${ctx.raw}`,
        },
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <div className="relative h-full w-full">
      {/* CENTER TEXT */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="text-xs text-gray-500">
          Total Duties
        </span>
        <span className="text-2xl font-bold text-gray-900">
          {total_duties}
        </span>
      </div>

      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DutySummaryDonut;
